export default function TasksSolved() {
  const tasks = [
    { icon: 'ri-chat-check-line', title: 'Повышение качества коммуникации', desc: 'Сотрудники учатся вести диалог осознанно: слушать, задавать правильные вопросы, аргументировать и договариваться о следующих шагах.' },
    { icon: 'ri-emotion-unhappy-line', title: 'Работа со сложными клиентами', desc: 'Алгоритмы работы с требовательными, эмоциональными и конфликтными клиентами. Сохраняем репутацию даже в сложных ситуациях.' },
    { icon: 'ri-sparkling-line', title: 'Сервис без шаблонов', desc: 'Учим не заученным фразам, а искренней, человеческой коммуникации. Клиенты чувствуют разницу между скриптом и настоящим вниманием.' },
    { icon: 'ri-search-eye-line', title: 'Выявление ожиданий клиента', desc: 'Техники выявления реальных потребностей и ожиданий. Большинство конфликтов возникает из-за того, что ожидания не были выявлены и согласованы.' },
    { icon: 'ri-shield-check-line', title: 'Построение доверия', desc: 'Как с первых минут общения создать атмосферу доверия, показать экспертизу и заинтересованность в результате клиента.' },
    { icon: 'ri-error-warning-line', title: 'Работа с претензиями', desc: 'Системный подход к работе с жалобами: от первой реакции до полного разрешения. Превращаем недовольного клиента в лояльного.' },
    { icon: 'ri-alert-line', title: 'Профилактика конфликтов', desc: 'Как распознать признаки назревающего конфликта и предотвратить его на ранней стадии, не доводя до эскалации.' },
    { icon: 'ri-heart-line', title: 'Удержание клиентов', desc: 'Стратегия удержания: touch-points, программа лояльности, регулярная обратная связь. Снижаем отток и увеличиваем LTV.' },
    { icon: 'ri-repeat-line', title: 'Повторные продажи', desc: 'Как выявлять возможности для дополнительных продаж, не будучи навязчивым. Технология роста доли в клиенте.' },
    { icon: 'ri-ghost-line', title: 'Работа с негативом', desc: 'Алгоритмы работы с негативными отзывами, публичными жалобами и репутационными рисками. Сохраняем лицо компании.' },
    { icon: 'ri-bar-chart-line', title: 'Рост NPS', desc: 'Внедрение системы измерения лояльности. Как связать качество коммуникации с индексом потребительской лояльности и ростом выручки.' },
    { icon: 'ri-building-line', title: 'Укрепление репутации компании', desc: 'Каждый контакт с клиентом формирует репутацию. Делаем так, чтобы каждый сотрудник становился сильным представителем бренда.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-task-line"></i>
            Что решает обучение
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие задачи решает обучение работе с клиентами
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системное обучение закрывает весь спектр задач — от первой коммуникации до долгосрочного удержания и роста LTV.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {tasks.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-5 md:p-6 hover:bg-teal-50/50 transition-colors group border border-transparent hover:border-teal-100">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-teal-600/15 transition-colors">
                  <i className={`${item.icon} text-teal-600 text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}